import _ from 'lodash';
import React, { Component } from 'react';
import axios from 'axios';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableContainer from '@material-ui/core/TableContainer';
import Switch from '@material-ui/core/Switch';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Paper from '@material-ui/core/Paper';
import Editor from './Editor';

function formatBytes(bytes) {
  if (!bytes || bytes === 0) return '0 Bytes';
  const k = 1024;
  const sizes = ['Bytes', 'KB', 'MB', 'GB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return `${parseFloat((bytes / Math.pow(k, i)).toFixed(1))} ${sizes[i]}`;
}


class Admin extends Component {
  constructor(props) {
    super(props);
    this.state = {
      username: '',
      password: '',
      successful: null,
      isLoggedIn: false,
      authChecked: false,
      activeTab: 0,
      guestbookEntries: [],
      aboutTitle: '',
      aboutContent: '',
      aboutPhotoUrl: '',
      aboutSaveStatus: null,
      mediaItems: [],
      fetchingMedia: false,
      copyToast: null,
    };
    this.onUsernameChange = this.onUsernameChange.bind(this);
    this.onPasswordChange = this.onPasswordChange.bind(this);
    this.onButtonClick = this.onButtonClick.bind(this);
    this.testButtonClick = this.testButtonClick.bind(this);
    this.submitFileClick = this.submitFileClick.bind(this);
    this.fetchGuestbook = this.fetchGuestbook.bind(this);
    this.fetchAbout = this.fetchAbout.bind(this);
    this.fetchMedia = this.fetchMedia.bind(this);
    this.handleDeleteMedia = this.handleDeleteMedia.bind(this);
    this.handleCopyUrl = this.handleCopyUrl.bind(this);
    this.saveAboutPage = this.saveAboutPage.bind(this);
    this.toggleVisibility = this.toggleVisibility.bind(this);
    this.handleTabChange = this.handleTabChange.bind(this);
    this.logout = this.logout.bind(this);
  }

  async componentDidMount() {
    try {
      const res = await axios.get('/api/user');
      const isLoggedIn = Boolean(_.get(res, 'data.isLoggedIn'));
      this.setState({ isLoggedIn, authChecked: true });
      if (isLoggedIn) {
        this.fetchGuestbook();
        this.fetchAbout();
        this.fetchMedia();
      } else {
        window.sessionStorage.removeItem('isLoggedIn');
      }
    } catch (err) {
      window.sessionStorage.removeItem('isLoggedIn');
      this.setState({ isLoggedIn: false, authChecked: true });
    }
  }

  onUsernameChange(e) {
    this.setState({ username: e.target.value });
  }

  onPasswordChange(e) {
    this.setState({ password: e.target.value });
  }

  handleTabChange(event, newValue) {
    this.setState({ activeTab: newValue });
  }

  async onButtonClick() {
    try {
      const { username, password } = this.state;
      const res = await axios.post('/api/login', {
        username,
        password,
      });
      window.sessionStorage.setItem('isLoggedIn', 'true');
      this.setState({
        successful: res.status === 200,
        isLoggedIn: res.status === 200,
      }, () => {
        if (this.state.isLoggedIn) {
          this.fetchGuestbook();
          this.fetchAbout();
          this.fetchMedia();
        }
      });
    } catch (err) {
      this.setState({ successful: false });
    }
  }

  async logout() {
    try {
      await axios.post('/api/logout');
    } finally {
      window.sessionStorage.removeItem('isLoggedIn');
      this.setState({ isLoggedIn: false, successful: null });
    }
  }

  async fetchGuestbook() {
    try {
      const res = await axios.get('/admin/guestbook');
      this.setState({ guestbookEntries: res.data });
    } catch (err) {
      console.error('Failed to fetch guestbook', err);
    }
  }

  async fetchAbout() {
    try {
      const res = await axios.get('/api/about');
      if (res.data) {
        this.setState({
          aboutTitle: res.data.title || '',
          aboutContent: res.data.content || '',
          aboutPhotoUrl: res.data.photo_url || res.data.photoUrl || '',
        });
      }
    } catch (err) {
      console.error('Failed to fetch About content', err);
    }
  }

  async fetchMedia() {
    this.setState({ fetchingMedia: true });
    try {
      const res = await axios.get('/admin/media');
      this.setState({ mediaItems: res.data || [], fetchingMedia: false });
    } catch (err) {
      console.error('Failed to fetch media gallery', err);
      this.setState({ fetchingMedia: false });
    }
  }

  async handleDeleteMedia(id) {
    if (window.confirm('Are you sure you want to delete this media item?')) {
      try {
        await axios.delete(`/admin/media/${id}`);
        this.fetchMedia();
      } catch (err) {
        console.error('Failed to delete media item', err);
      }
    }
  }

  handleCopyUrl(url) {
    if (navigator.clipboard) {
      navigator.clipboard.writeText(url);
      this.setState({ copyToast: 'URL copied to clipboard!' });
      setTimeout(() => this.setState({ copyToast: null }), 3000);
    }
  }

  async saveAboutPage() {
    try {
      const { aboutTitle, aboutContent, aboutPhotoUrl } = this.state;
      await axios.post('/admin/about', {
        title: aboutTitle,
        content: aboutContent,
        photo_url: aboutPhotoUrl,
      });
      this.setState({ aboutSaveStatus: 'success' });
      setTimeout(() => this.setState({ aboutSaveStatus: null }), 4000);
    } catch (err) {
      console.error('Failed to save About page', err);
      this.setState({ aboutSaveStatus: 'error' });
    }
  }

  async toggleVisibility(id, currentVisibility) {
    try {
      const newVisibility = !currentVisibility;
      await axios.post('/admin/guestbook/visibility', {
        id,
        visible: newVisibility,
      });
      this.fetchGuestbook();
    } catch (err) {
      console.error('Failed to toggle visibility', err);
    }
  }

  async testButtonClick() {
    await axios.post('/admin/addpost', {
      title: 'hi',
    });
  }

  async submitFileClick(e) {
    e.preventDefault();
    const file = _.first(document.querySelector('#upload-file').files);
    if (!file) return;
    const formData = new FormData();
    formData.append('photo', file);
    this.setState({ uploading: true });
    try {
      const res = await axios.post('/admin/file', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      this.setState({ uploadedFileName: res.data.location, uploading: false });
      this.fetchMedia();
    } catch (err) {
      console.error('Failed to upload file', err);
      this.setState({ uploading: false });
    }
  }

  render() {
    const {
      successful,
      username,
      password,
      isLoggedIn,
      authChecked,
      activeTab,
      uploadedFileName,
      uploading,
      aboutTitle,
      aboutContent,
      aboutPhotoUrl,
      aboutSaveStatus,
      mediaItems,
      fetchingMedia,
      copyToast,
    } = this.state;
    if (!authChecked) {
      return <div>Checking session...</div>;
    }
    if (isLoggedIn) {
      return (
        <div style={{ maxWidth: '100%', overflowX: 'hidden' }}>
          <Paper square style={{ marginBottom: '20px', maxWidth: '100%' }}>
            <Tabs
              value={activeTab}
              onChange={this.handleTabChange}
              indicatorColor="primary"
              textColor="primary"
              variant="scrollable"
              scrollButtons="auto"
            >
              <Tab label="About Page" />
              <Tab label="Guestbook" />
              <Tab label="Blog Posts" />
              <Tab label="File Uploads" />
            </Tabs>
            <Button size="small" onClick={this.logout} style={{ margin: '8px' }}>
              Logout
            </Button>
          </Paper>

          {activeTab === 0 && (
            <div className="about-management-wrapper" style={{ margin: '20px 0', padding: '15px', backgroundColor: 'white', borderRadius: '4px', border: '1px solid #ccc', boxSizing: 'border-box', maxWidth: '100%' }}>
              <h3>About Page Configuration</h3>
              <div style={{ marginBottom: '15px' }}>
                <TextField
                  label="Title"
                  variant="outlined"
                  fullWidth
                  value={aboutTitle}
                  onChange={(e) => this.setState({ aboutTitle: e.target.value })}
                />
              </div>
              <div style={{ marginBottom: '15px' }}>
                <TextField
                  label="Content / Text"
                  variant="outlined"
                  multiline
                  rows={6}
                  fullWidth
                  value={aboutContent}
                  onChange={(e) => this.setState({ aboutContent: e.target.value })}
                />
              </div>
              <div style={{ marginBottom: '15px' }}>
                <TextField
                  label="Photo URL"
                  variant="outlined"
                  fullWidth
                  value={aboutPhotoUrl}
                  onChange={(e) => this.setState({ aboutPhotoUrl: e.target.value })}
                />
                {uploadedFileName && (
                  <Button
                    size="small"
                    style={{ marginTop: '5px' }}
                    onClick={() => this.setState({ aboutPhotoUrl: uploadedFileName })}
                  >
                    Use Last Uploaded File URL
                  </Button>
                )}
              </div>
              <div style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: '10px' }}>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={this.saveAboutPage}
                >
                  Save About Page
                </Button>
                {aboutSaveStatus === 'success' && (
                  <span className="success-text">About page saved successfully!</span>
                )}
                {aboutSaveStatus === 'error' && (
                  <span className="failure-text">Failed to save About page.</span>
                )}
              </div>
            </div>
          )}

          {activeTab === 1 && (
            <div className="guestbook-management-wrapper" style={{ margin: '20px 0', padding: '15px', backgroundColor: 'white', borderRadius: '4px', border: '1px solid #ccc', boxSizing: 'border-box', maxWidth: '100%' }}>
              <h3>Guestbook Management</h3>
              <TableContainer style={{ overflowX: 'auto', width: '100%' }}>
                <Table style={{ minWidth: '500px' }}>
                  <TableHead>
                    <TableRow>
                      <TableCell style={{ fontWeight: 'bold' }}>Name</TableCell>
                      <TableCell style={{ fontWeight: 'bold' }}>Message</TableCell>
                      <TableCell style={{ fontWeight: 'bold' }}>Location</TableCell>
                      <TableCell style={{ fontWeight: 'bold' }}>Date</TableCell>
                      <TableCell style={{ fontWeight: 'bold' }}>Visible</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {this.state.guestbookEntries.map(entry => (
                      <TableRow key={entry.id}>
                        <TableCell style={{ whiteSpace: 'normal', wordBreak: 'break-word', minWidth: '90px' }}>{entry.user_name}</TableCell>
                        <TableCell style={{ whiteSpace: 'normal', wordBreak: 'break-word', minWidth: '160px' }}>{entry.message}</TableCell>
                        <TableCell style={{ whiteSpace: 'normal', wordBreak: 'break-word', minWidth: '90px' }}>{entry.location}</TableCell>
                        <TableCell style={{ minWidth: '110px' }}>{new Date(entry.received_at).toLocaleString()}</TableCell>
                        <TableCell style={{ width: '70px' }}>
                          <Switch
                            checked={Boolean(entry.visible)}
                            onChange={() => this.toggleVisibility(entry.id, entry.visible)}
                            color="primary"
                          />
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </div>
          )}

          {activeTab === 2 && (
            <div style={{ maxWidth: '100%', overflowX: 'hidden' }}>
              <Editor />
            </div>
          )}

          {activeTab === 3 && (
            <div>
              <div className="upload-wrapper" style={{ margin: '20px 0', padding: '20px', backgroundColor: 'white', borderRadius: '4px', border: '1px solid #ccc', boxSizing: 'border-box', maxWidth: '100%' }}>
                <h3>Upload a file to AWS S3</h3>
                <input type="file" id="upload-file" style={{ maxWidth: '100%' }} />
                <Button variant="contained" color="primary" id="submit-file" onClick={this.submitFileClick} style={{ marginTop: '15px' }}>
                  Submit Upload
                </Button>
                <div style={{ marginTop: '15px', wordBreak: 'break-all' }}>
                  {uploading ? 'Uploading...' : uploadedFileName ? `File is now available at: ${uploadedFileName}` : ''}
                </div>
                {copyToast && (
                  <div className="success-text" style={{ marginTop: '10px' }}>{copyToast}</div>
                )}
              </div>

              <div className="media-gallery-wrapper" style={{ margin: '20px 0', padding: '20px', backgroundColor: 'white', borderRadius: '4px', border: '1px solid #ccc', boxSizing: 'border-box', maxWidth: '100%' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '15px', flexWrap: 'wrap', gap: '10px' }}>
                  <h3 style={{ margin: 0 }}>S3 Media Gallery & Assets ({mediaItems.length})</h3>
                  <Button size="small" onClick={this.fetchMedia} disabled={fetchingMedia}>
                    {fetchingMedia ? 'Refreshing...' : 'Refresh Gallery'}
                  </Button>
                </div>

                {mediaItems.length === 0 ? (
                  <div style={{ padding: '20px', textAlign: 'center', color: '#666' }}>
                    No uploaded media items found in gallery yet. Upload a file above to add it to your S3 asset library.
                  </div>
                ) : (
                  <div style={{
                    display: 'grid',
                    gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))',
                    gap: '15px',
                  }}>
                    {mediaItems.map((item) => {
                      const filenameLower = (item.filename || item.original_name || item.url || '').toLowerCase();
                      const isImage = (item.mime_type && item.mime_type.startsWith('image/')) || filenameLower.match(/\.(jpg|jpeg|png|gif|webp)$/i);
                      const isPdf = item.mime_type === 'application/pdf' || filenameLower.endsWith('.pdf') || filenameLower.includes('pdf');
                      const isAudio = (item.mime_type && item.mime_type.startsWith('audio/')) || filenameLower.match(/\.(mp3|wav|m4a|aac)$/i);

                      let fileLabel = 'DOCUMENT';
                      let fileIcon = '📄';
                      let badgeBg = '#e3f2fd';
                      let badgeColor = '#1565c0';

                      if (isPdf) {
                        fileLabel = 'PDF DOCUMENT';
                        fileIcon = '📕';
                        badgeBg = '#ffebee';
                        badgeColor = '#c62828';
                      } else if (isAudio) {
                        fileLabel = 'AUDIO FILE';
                        fileIcon = '🎵';
                        badgeBg = '#f3e5f5';
                        badgeColor = '#6a1b9a';
                      }

                      return (
                        <div key={item.id} style={{
                          border: '1px solid #e0e0e0',
                          borderRadius: '6px',
                          overflow: 'hidden',
                          display: 'flex',
                          flexDirection: 'column',
                          backgroundColor: '#fafafa',
                        }}>
                          <div style={{
                            height: '140px',
                            backgroundColor: isImage ? '#e0e0e0' : (isPdf ? '#fff0f0' : '#f5f5f5'),
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            justifyContent: 'center',
                            overflow: 'hidden',
                          }}>
                            {isImage ? (
                              <img
                                src={item.url}
                                alt={item.original_name || item.filename}
                                style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                              />
                            ) : (
                              <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '6px' }}>
                                <span style={{ fontSize: '36px' }}>{fileIcon}</span>
                                <span style={{
                                  fontSize: '11px',
                                  fontWeight: 'bold',
                                  color: badgeColor,
                                  backgroundColor: badgeBg,
                                  padding: '3px 10px',
                                  borderRadius: '4px',
                                  letterSpacing: '0.5px',
                                }}>
                                  {fileLabel}
                                </span>
                              </div>
                            )}
                          </div>
                          <div style={{ padding: '10px', flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
                            <div>
                              <div
                                title={item.original_name || item.filename}
                                style={{
                                  fontWeight: 'bold',
                                  fontSize: '13px',
                                  overflow: 'hidden',
                                  textOverflow: 'ellipsis',
                                  whiteSpace: 'nowrap',
                                  marginBottom: '4px',
                                }}
                              >
                                {item.original_name || item.filename}
                              </div>
                              <div style={{ fontSize: '11px', color: '#666', marginBottom: '8px' }}>
                                {item.file_size > 0 ? formatBytes(item.file_size) : 'S3 Asset'} • {new Date(item.created_at).toLocaleDateString()}
                              </div>
                            </div>
                            <div style={{ display: 'flex', flexDirection: 'column', gap: '5px' }}>
                              <Button
                                size="small"
                                variant="outlined"
                                color="primary"
                                onClick={() => this.handleCopyUrl(item.url)}
                                style={{ fontSize: '11px', padding: '2px 5px' }}
                              >
                                📋 Copy URL
                              </Button>
                              {isImage && (
                                <Button
                                  size="small"
                                  variant="outlined"
                                  onClick={() => this.setState({ aboutPhotoUrl: item.url, activeTab: 0 })}
                                  style={{ fontSize: '11px', padding: '2px 5px' }}
                                >
                                  🖼 Use on About Page
                                </Button>
                              )}
                              <Button
                                size="small"
                                color="secondary"
                                onClick={() => this.handleDeleteMedia(item.id)}
                                style={{ fontSize: '11px', padding: '2px 5px' }}
                              >
                                🗑 Delete
                              </Button>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                )}
              </div>
            </div>
          )}
        </div>
      );
    } return (
      <Card id="login">
        <CardHeader title="Sign In" />
        {successful === true && <div className="success-text">Sign in successful</div>}
        {successful === false && <div className="failure-text">Sign in unsuccessful</div>}
        <TextField id="username" variant="outlined" value={username} onChange={this.onUsernameChange} placeholder="Username" />
        <TextField id="password" type="password" variant="outlined" value={password} onChange={this.onPasswordChange} placeholder="Password" />
        <Button variant="contained" color="primary" onClick={this.onButtonClick}>
          Login
        </Button>
      </Card>
    );
  }
}

export default Admin;
